/**
 * If the country is USA, return the list of states, if the country is Canada, return the list of
 * provinces, otherwise return the list of 'No Country'.
 * @param [country] - The country you want to get the states for.
 * @returns An array of strings.
 */
export const getStates = (country="") => {
  switch (country) {
    case "USA"||"US":
      return ['AK','AL','AR','AZ','CA','CO','CT','DC','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY'];
    case "Canada":
        return ['AB','BC','MB','NB','NL','NS','NT','NU','ON','PE','QC','SK','YT'];
    default:
      return ['No Country'];
  }
};
export default getStates;
